const RelatedDocuments = function(detailResultService) {

  const template = `
    <div ng-show="record.state == 'OK'">
      <div class="row">
        <div class="main-header"> Related Documents </div>
      </div>
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Image</th>
            <th>Description</th>
            <th>Effective Date</th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="attachment in attachments | orderBy:'-metaData.effective_date'">
            <td>
              <a ng-href="{{ attachment.attachmentUrl }}" target="_blank"> {{ attachment.label }} </a>
            </td>
            <td>{{ attachment.form }}</td>
            <td>{{ attachment.metaData.effective_date }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  `

  function link($scope) {
    $scope.attachments = detailResultService.queryRelatedDocuments($scope.record)
  }

  return {
    template: template,
    link: link,
    scope: {
      record: '='
    }
  }
}

RelatedDocuments.$inject = [ 'DetailResultService' ]

export default RelatedDocuments
